import { Navigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import type { Permission } from "../../lib/permissions";

interface RequirePermissionRouteProps {
  permission: Permission;
  children: React.ReactNode;
  /** Where to send users who lack the permission. Defaults to the dashboard. */
  redirectTo?: string;
}

/**
 * Route-level permission guard: renders children if the user has `permission`
 * (owner/admin bypass), otherwise redirects. Use to protect deep-links to pages
 * that are also hidden from the Sidebar. UX only — the server still enforces.
 */
export function RequirePermissionRoute({
  permission,
  children,
  redirectTo = "/dashboard",
}: RequirePermissionRouteProps) {
  const allowed = usePermission(permission);
  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
